<div class="title p-2 viewDocumentSectionTitle">
    <div class="row">
        <div class="col d-flex justify-content-between align-items-center">
            <h1 class="mx-2 mt-3">
                <span>Info contract
                    {{ contract?.nr_contract ? contract?.nr_contract : 'N/A' }} /
                    {{ contract?.data_contract ? formatDate(contract?.data_contract) : 'N/A' }}
                </span>
                <span class="text-secondary m-2">#{{ contract?.id }}</span>
                <button type="button" class="btn btn-small btn-primary" (click)="getContractInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span class="ms-2"> Reîncarcă informații</span>
                </button>
                <button type="button" class="btn btn-small btn-info ms-2" (click)="downloadFile(contract!.id)">
                    <i class="fa-solid fa-print"></i>
                    <span class="ms-2"> Print</span>
                </button>
                <button *ngIf="contract?.status !== 'reziliat'" type="button" class="btn btn-small btn-danger ms-2"
                    (click)="reziliereContract(contract!.id)">
                    <i class="fa-solid fa-trash-can"></i>
                    <span class="ms-2"> Reziliere contract</span>
                </button>
            </h1>
        </div>
        <div class="col-md-6 d-flex justify-content-end align-items-center">
            <div class="px-2 d-flex flex-column border-end border-dark hide-content">
                <span class="fw-bold">
                    {{ activeAccess?.denumire_directie }}
                </span>
                <span>
                    {{ activeAccess?.denumire_compartiment || 'n/a' }}
                </span>
            </div>
            <div class="px-2 d-flex flex-column">
                <span class="fw-bold">{{ user?.name || 'n/a' }}</span>
                <span>{{ activeFunction?.functie_name || 'n/a' }}</span>
            </div>
            <button type="button" class="ps-2 action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="row p-3 responsive-content viewDocumentContentSection">
    <div class="col-lg-8">
        <mat-card>
            <app-subsemnat *ngIf="contract" [contract]="contract"></app-subsemnat>

            <app-mesagerie *ngIf="contract" [contract]="contract" (contractChanged)="getContractInfo()"></app-mesagerie>

            <app-istoric *ngIf="contract && contract.history && user" [contract]="contract" [history]="contract.history"
                [user]="user" (isLoading)="onIsLoadingChange($event)"></app-istoric>
        </mat-card>
    </div>
    <div class="col-4">
        <mat-card>
            <div class="g-0">
                <div class="row">
                    <div class="col">
                        <div class="box-wrapper box-info">
                            <div class="box-content-header">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-card-title>
                                            <i class="fa-solid fa-file-contract"></i>
                                            <span>Detalii Contract</span>
                                        </mat-card-title>
                                    </div>
                                </div>
                            </div>
                            <div class="box-content-body">
                                <table class="table table-condensed table-wrapper-box mb-0">
                                    <tbody>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong><i class="fa-solid fa-hashtag me-1"></i>Nr. Contract</strong>
                                            </td>
                                            <td class="text-left">{{ contract?.nr_contract || 'N/A' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-day me-1"></i>Dată
                                                    contract</strong>
                                            </td>
                                            <td class="text-left">{{ formatDate(contract?.data_contract) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-plus me-1"></i>Dată
                                                    început</strong>
                                            </td>
                                            <td class="text-left">{{ formatDate(contract?.date_from_contract) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-xmark me-1"></i>Dată
                                                    sfârșit</strong>
                                            </td>
                                            <td class="text-left">{{ formatDate(contract?.date_end_contract) }}</td>
                                        </tr>
                                        <!-- <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-circle-check me-1"></i>Status</strong>
                                </td>
                                <td class="text-left">
                                    <span class="badge"
                                        [ngStyle]="{ 'background-color': contract?.active ? '#39612C' : '#dd4b39', 'color': 'white' }">
                                        {{ contract?.active ? 'Activ' : 'Inactiv' }}
                                    </span>
                                </td>
                            </tr> -->
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-user-pen me-1"></i>Creat de</strong>
                                            </td>
                                            <td class="text-left">{{ contract?.created_by_user_name || 'N/A' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-documente [contract]="contract" (contractChanged)="getContractInfo()"></app-documente>
        </mat-card>
    </div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>